import { render, staticRenderFns } from "./ApwPlanList.vue?vue&type=template&id=565fbae2&scoped=true&"
import script from "./ApwPlanList.vue?vue&type=script&lang=js&"
export * from "./ApwPlanList.vue?vue&type=script&lang=js&"
import style0 from "./ApwPlanList.vue?vue&type=style&index=0&id=565fbae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565fbae2",
  null
  
)

export default component.exports